export enum HotelType {
  HOTEL_RESTAURANT = 'HOTEL_RESTAURANT',

  HOTEL_RESTAURANT_VENUE = 'HOTEL_RESTAURANT_VENUE',

  HOTEL_VENUE = 'HOTEL_VENUE',
}
